<template>
  <v-row class="ma-0 poppins">
    <v-col
      cols="12"
      class="p-4 bg-white rounded-lg h-100 custom-container-height"
    >
      <div class="mx-0 mx-sm-8 mt-4">
        <datatable-detail
          class="col-9 col-md-9 col-sm-9"
          :table_properties="pageProperties"
        />
      </div>
      <v-col class="mt-8 mb-12 mx-0 mx-sm-10 pa-sm-0" cols="12">
        <div class="mb-10 d-flex align-center">
          <v-icon color="#9EA1B6">info</v-icon>
          <h3 class="ml-4 mb-0 poppins" style="color: #263238; font-size: 24px">
            Scan Order
          </h3>
        </div>
        <div class="row ma-0">
          <div class="col-12 col-md-4">
            <v-text-field
              v-model="order_identifier"
              class="poppins"
              append-icon="mdi-barcode-scan"
              label="Scan order number or delivery number"
              outlined
              clearable
              autofocus
            />
          </div>
          <div class="col-12 col-md-5 d-flex">
            <v-autocomplete
              v-model="type"
              label="Document type"
              :items="print_types"
              item-text="text"
              item-value="index"
              outlined
              clearable
              hide-details
              hide-spin-buttons
            />

            <div>
              <button
                @click="handleClickBarcode"
                class="btn btn--export-filter ms-4 h-55px w-150px font-size-h5 ls1"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-printer</v-icon>
                </span>
                Print
              </button>
            </div>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";

export default {
  name: "Print",
  components: { DatatableDetail },
  data: function () {
    return {
      order_identifier: "",
      type: "shipping_label",
      print_types: {},
    };
  },
  computed: {
    pageProperties: function () {
      return {
        title: "Print",
        description: "Print Management",
      };
    },
  },
  methods: {
    handleClickBarcode: function () {
      if (this.order_identifier && this.type) {
        this.$store.commit(SET_PAGE_LOADING, true);
        ApiService.post("/fulfillment/print/print", {
          order_identifier: this.order_identifier,
          type: this.type,
        })
          .then(({ data }) => {
            if (data.success) {
              const link = document.createElement("a");
              link.href = data.path[0];
              link.target = "_blank";
              link.download = "print.csv";
              link.click();
              link.remove();
            } else {
              Swal.fire({
                title: `Warning`,
                icon: "warning",
                text: data.message,
              });
            }
            this.order_identifier = "";
            this.type = "shipping_label";
          })
          .finally(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      } else {
        Swal.fire({
          title: `Warning`,
          icon: "warning",
          text: `Please provide order number and document type to proceed further.`,
        });
      }
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);

    ApiService.post("/fulfillment/print")
      .then(({ data }) => {
        this.print_types = data.print_types;
      })
      .finally(() => {
        this.$store.commit(SET_PAGE_LOADING, false);
      });
  },
};
</script>

<style scoped>
.v-application .text-h6 {
  font-family: "Poppins", sans-serif !important;
}

.custom-container-height {
  overflow-y: scroll;
  position: relative;
  height: calc(100vh - 171px) !important;
}

@media (max-width: 1199.98px) {
  .custom-container-height {
    height: calc(100vh - 141px) !important;
  }
}

@media (max-width: 991.98px) {
  .custom-container-height {
    height: calc(100vh - 127px) !important;
  }
}
</style>
